export const ALLOWED_EVIDENCE_UPLOAD_FILE_TYPES = ['image/jpeg', 'image/png', 'video/mp4', 'video/quicktime'].join(
  ', '
);

export type MaterialCategoryName =
  // PET Categories
  | 'PET Clear Bottle'
  | 'PET Target'
  | 'PET Bottle Clear'
  | 'Light blue'
  | 'Dark blue'
  | 'Green'
  | 'PET Bottle Turquoise'
  | 'PET Bottle Brown'
  | 'PET Bottle White'
  | 'Other colour'
  | 'Clear tray'
  | 'PET Tray Contaminated Clear'
  | 'Very Large PET Bottle'
  | 'PET Bottle Large Clear'
  | 'Clear Non-Food grade'
  | 'Film'
  | 'Other Plastic'
  | 'Liquids'
  | 'Clear Mouthwash Bottle'
  | 'Hanger'
  | 'Rigid Plastic'
  | 'Cardboard'
  | 'Paper'
  | 'Tetra Pak'
  | 'Textile'
  | 'Wood'
  | 'Glass'
  | 'Netting'
  | 'Non Plastic'
  | 'Metal'
  | 'Other Metal'
  | 'Ferrous Metal'
  | 'Aluminium Aerosol'
  | 'Aluminium Beverage Cans'
  | 'Aluminium Foil Trays'
  | 'Aluminium Food Can'
  | 'Aluminium Caps'
  | 'Aluminium Bottles'
  | 'Aluminium Other'
  | 'Scraps'
  | 'Vapes'
  | 'Lighters'
  | 'WEEE'
  // ALU Categories
  | 'Non-Metal'
  | 'Non Metallic'
  | 'Fibers & Textile'
  | 'Small Plastic'
  | 'Other Aluminium'
  | 'Steel'
  | 'bale_strap'
  | 'Bale ID Tag'
  | 'Non-Target'
  | 'Loose Material Box'
  | 'Boot'
  | 'UBC Target';

export interface MaterialCategory {
  name: MaterialCategoryName;
  colour: [number, number, number];
  is_colour?: boolean;
  is_non_target?: boolean;
  encord_class_names?: string[];
}

// created from https://github.com/saficorp/remote-inspection/blob/main/data/taxonomy/pet.yaml
export const PET_MATERIAL_CATEGORIES = new Map<MaterialCategoryName, MaterialCategory>([
  ['PET Clear Bottle', { colour: [58, 184, 185], name: 'PET Clear Bottle' }],
  ['PET Target', { colour: [58, 184, 185], name: 'PET Target' }], // Deprecated category
  ['PET Bottle Clear', { colour: [58, 184, 185], name: 'PET Bottle Clear' }],
  ['Light blue', { colour: [130, 177, 255], is_colour: true, name: 'Light blue' }],
  ['Dark blue', { colour: [13, 71, 161], is_colour: true, is_non_target: true, name: 'Dark blue' }],
  ['Green', { colour: [67, 160, 71], is_colour: true, is_non_target: true, name: 'Green' }],
  [
    'PET Bottle Turquoise',
    { colour: [5, 221, 171], is_colour: true, is_non_target: true, name: 'PET Bottle Turquoise' },
  ],
  ['PET Bottle Brown', { colour: [150, 70, 0], is_colour: true, name: 'PET Bottle Brown' }],
  ['PET Bottle White', { colour: [155, 156, 151], is_colour: true, name: 'PET Bottle White' }],
  ['Other colour', { colour: [255, 255, 64], is_colour: true, is_non_target: true, name: 'Other colour' }],
  // Non Target Plastics
  ['Clear tray', { colour: [7, 235, 129], is_non_target: true, name: 'Clear tray' }],
  ['PET Tray Contaminated Clear', { colour: [7, 235, 129], is_non_target: true, name: 'PET Tray Contaminated Clear' }],
  ['Very Large PET Bottle', { colour: [255, 40, 255], is_non_target: true, name: 'Very Large PET Bottle' }],
  ['PET Bottle Large Clear', { colour: [255, 40, 255], is_non_target: true, name: 'PET Bottle Large Clear' }],
  ['Clear Non-Food grade', { colour: [255, 247, 37], is_non_target: true, name: 'Clear Non-Food grade' }],
  ['Film', { colour: [202, 198, 46], is_non_target: true, name: 'Film' }],
  ['Other Plastic', { colour: [255, 20, 138], is_non_target: true, name: 'Other Plastic' }],
  ['Liquids', { colour: [162, 54, 255], encord_class_names: ['Liquids', 'Liquides'], name: 'Liquids' }],
  ['Clear Mouthwash Bottle', { colour: [128, 128, 32], is_non_target: false, name: 'Clear Mouthwash Bottle' }],
  ['Hanger', { colour: [188, 48, 200], is_non_target: true, name: 'Hanger' }],
  ['Rigid Plastic', { colour: [255, 20, 129], is_non_target: true, name: 'Rigid Plastic' }],
  // Non Plastics
  ['Cardboard', { colour: [213, 202, 25], is_non_target: true, name: 'Cardboard' }],
  ['Paper', { colour: [126, 137, 0], is_non_target: true, name: 'Paper' }],
  ['Tetra Pak', { colour: [174, 161, 255], is_non_target: true, name: 'Tetra Pak' }],
  ['Textile', { colour: [77, 149, 87], is_non_target: true, name: 'Textile' }],
  ['Wood', { colour: [157, 30, 242], is_non_target: true, name: 'Wood' }],
  ['Glass', { colour: [0, 165, 188], is_non_target: true, name: 'Glass' }],
  ['Netting', { colour: [255, 138, 101], is_non_target: true, name: 'Netting' }],
  ['Non Plastic', { colour: [255, 162, 38], is_non_target: true, name: 'Non Plastic' }],
  // Metals
  ['Metal', { colour: [255, 32, 32], is_non_target: true, name: 'Metal' }],
  ['Other Metal', { colour: [255, 32, 32], is_non_target: true, name: 'Other Metal' }],
  ['Ferrous Metal', { colour: [255, 32, 32], is_non_target: true, name: 'Ferrous Metal' }],
  ['Aluminium Aerosol', { colour: [145, 16, 253], is_non_target: true, name: 'Aluminium Aerosol' }],
  ['Aluminium Beverage Cans', { colour: [147, 14, 16], is_non_target: true, name: 'Aluminium Beverage Cans' }],
  ['Aluminium Foil Trays', { colour: [255, 201, 7], is_non_target: true, name: 'Aluminium Foil Trays' }],
  ['Aluminium Food Can', { colour: [13, 71, 161], is_non_target: true, name: 'Aluminium Food Can' }],
  ['Aluminium Caps', { colour: [222, 255, 0], is_non_target: true, name: 'Aluminium Caps' }],
  ['Aluminium Bottles', { colour: [163, 150, 12], is_non_target: true, name: 'Aluminium Bottles' }],
  ['Aluminium Other', { colour: [255, 128, 0], is_non_target: true, name: 'Aluminium Other' }],
  ['Scraps', { colour: [160, 255, 34], is_non_target: true, name: 'Scraps' }],
  // Prohibitives
  ['Vapes', { colour: [133, 126, 255], is_non_target: true, name: 'Vapes' }],
  ['Lighters', { colour: [226, 45, 255], is_non_target: true, name: 'Lighters' }],
  ['WEEE', { colour: [32, 32, 255], is_non_target: true, name: 'WEEE' }],
]);

// created from https://github.com/saficorp/remote-inspection/blob/main/data/taxonomy/alu.yaml
export const ALU_MATERIAL_CATEGORIES = new Map<MaterialCategoryName, MaterialCategory>([
  ['Non-Metal', { colour: [89, 255, 13], is_non_target: true, name: 'Non-Metal' }],
  ['Rigid Plastic', { colour: [255, 20, 129], is_non_target: true, name: 'Rigid Plastic' }],
  ['Non Metallic', { colour: [89, 255, 0], is_non_target: true, name: 'Non Metallic' }],
  ['Fibers & Textile', { colour: [0, 155, 48], is_non_target: true, name: 'Fibers & Textile' }],
  ['Scraps', { colour: [160, 255, 34], is_non_target: true, name: 'Scraps' }],
  ['Small Plastic', { colour: [32, 237, 138], is_non_target: true, name: 'Small Plastic' }],
  ['Film', { colour: [255, 247, 37], is_non_target: true, name: 'Film' }],
  ['Aluminium Bottles', { colour: [163, 150, 12], is_non_target: true, name: 'Aluminium Bottles' }],
  ['Aluminium Foil Trays', { colour: [255, 201, 7], is_non_target: true, name: 'Aluminium Foil Trays' }],
  ['Aluminium Caps', { colour: [222, 255, 0], is_non_target: true, name: 'Aluminium Caps' }],
  ['Other Aluminium', { colour: [130, 177, 255], is_non_target: true, name: 'Other Aluminium' }],
  ['Other Metal', { colour: [10, 198, 255], is_non_target: true, name: 'Other Metal' }],
  ['Steel', { colour: [10, 198, 255], is_non_target: true, name: 'Steel' }],
  ['Aluminium Aerosol', { colour: [145, 16, 253], is_non_target: true, name: 'Aluminium Aerosol' }],
  ['Aluminium Food Can', { colour: [13, 71, 161], is_non_target: true, name: 'Aluminium Food Can' }],
  ['bale_strap', { colour: [20, 200, 20], name: 'bale_strap' }],
  ['Bale ID Tag', { colour: [20, 200, 20], encord_class_names: ['bale_id_tag'], name: 'Bale ID Tag' }],
  ['Vapes', { colour: [133, 126, 255], is_non_target: true, name: 'Vapes' }],
  ['Lighters', { colour: [226, 45, 255], is_non_target: true, name: 'Lighters' }],
  ['WEEE', { colour: [32, 32, 255], is_non_target: true, name: 'WEEE' }],
  ['Non-Target', { colour: [255, 0, 0], name: 'Non-Target' }],
  ['Loose Material Box', { colour: [0, 200, 0], name: 'Loose Material Box' }],
  ['Boot', { colour: [200, 200, 200], name: 'Boot' }],
  ['UBC Target', { colour: [58, 184, 185], name: 'UBC Target' }],
]);
